import { FC } from 'react'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import useResignedEmployeesOfCompanyCountry from '../../../graphql/resignedEmployee/hooks/useResignedEmployeesOfCompanyCountry'
import { ResignedEmployeesInfoBox } from './ResignedEmployeesInfoBox'
import { ResignedEmployeesList } from './ResignedEmployeesList'
import { ResignedEmployeeDto } from '../../../types'
import shallow from 'zustand/shallow'
import { useEmployeeStore } from '../EmployeeStore'
import { EmployeesWithWrongStatusOrMissingContractDto } from '../../../../../integration-tests/common/types'

export const ResignedEmployeesView: FC = () => {
  const [selected, employeeLevels] = useEmployeeStore((state) => [state.selected, state.employeeLevels], shallow)

  const { data, error, loading } = useResignedEmployeesOfCompanyCountry(selected.companyId)

  if (loading || error || !data || !data.resignedEmployeesOfCompanyCountry) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} />
  }

  const employeeList: ResignedEmployeeDto[] = data.resignedEmployeesOfCompanyCountry.resignedEmployees.filter(
    (employee) => employee.businessUnit.id === selected.buId || selected.isAllBu,
  )

  const employeesWithWrongStatusOrMissingContract: EmployeesWithWrongStatusOrMissingContractDto[] =
    data.resignedEmployeesOfCompanyCountry.employeesWithWrongStatusOrMissingContractDTO.filter(
      (employee) => employee.businessUnitId === selected.buId || selected.isAllBu,
    )

  return (
    <>
      <ResignedEmployeesInfoBox
        totalOfEmployees={employeeList.length}
        employeesWithWrongStatusOrMissingContract={employeesWithWrongStatusOrMissingContract}
      />
      <ResignedEmployeesList listData={employeeList} employeeLevels={employeeLevels} />
    </>
  )
}
